export enum ResourceTypes{
    InHouse = 1,
    Freelancer = 2,
    External = 2,
    ProjectManager = 4,
    Employee = 5
}